/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Unlock_3dInputs */

const en_camera_unlock_3d = /** @type {(inputs: Camera_Unlock_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop following`)
};

const fr_camera_unlock_3d = /** @type {(inputs: Camera_Unlock_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus suivre`)
};

const ms_sg2_camera_unlock_3d = /** @type {(inputs: Camera_Unlock_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti ikut`)
};

/**
* | output |
* | --- |
* | "Stop following" |
*
* @param {Camera_Unlock_3dInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_unlock_3d = /** @type {((inputs?: Camera_Unlock_3dInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Unlock_3dInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_unlock_3d(inputs)
	if (locale === "fr") return fr_camera_unlock_3d(inputs)
	return ms_sg2_camera_unlock_3d(inputs)
});